<template>
  <div class="date-picker-dialog-container" v-if="showDatePicker">
    <wxc-overlay :left='left' :show="true" :hasAnimation="false"></wxc-overlay>
    <div class="dialog-box" :style="{top:top+'px', left: left + 'px', right: right + 'px'}">
      <div class="dialog-content-without-cross">
        <weex-text class="item-heading">{{selectDateTitle}}</weex-text>

        <v-date-picker
          class="margin_top_20"
          :value="defaultSelectedDate"
          @input="dateSelected"
          :max="maxAllowedDate"
          :min="minAllowedDate"
        ></v-date-picker>

        <wxc-button
          v-if="allowClose"
          :text="closeText"
          size="small"
          type="red"
          class="horizontal_center margin_top_40"
          @wxcButtonClicked="onCloseClicked"
        ></wxc-button>

      </div>
    </div>
  </div>
</template>

<script>
import WxcOverlay from "../../../weex-ui/packages/wxc-overlay/index";
import WxcButton from "../../../weex-ui/packages/wxc-button/index";

export default {
  components: { WxcOverlay, WxcButton },
  props: {
    showDatePicker: {
      type: Boolean,
      default: false
    },

    defaultSelectedDate: {
      type: String,
      default: "1995-01-01"
    },

    maxAllowedDate: {
      type: String,
      default: undefined
    },

    minAllowedDate: {
      type: String,
      default: undefined
    },

    selectDateTitle: {
      type: String,
      default: "Select Date"
    },

    closeText: {
      type: String,
      default: "Close"
    },

    allowClose: {
      type: Boolean,
      default: true
    },

    top: {
      type: Number,
      default: 20
    },

    left: {
      type: Number,
      default: 0
    },

    right: {
      type: Number,
      default: 0
    }
  },
  data: () => ({}),

  methods: {
    dateSelected(e) {
      this.$emit("dateSelected", e);
    },

    onCloseClicked() {
      this.$emit("closeClicked");
    }
  }
};
</script>

<style scoped src="../../assets/style/base.css"></style>

<style scoped>
.date-picker-dialog-container {
  position: fixed;
  z-index: 9999;
}
</style>
